import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { i18n } from './i18n/index'
import router from './router'
import App from './App.vue'
import { loadConfigurationAsync } from './composables/Configuration'
import { useAppStore } from './stores/appStore'
import { useAidaSessionStore } from './stores/aidaSessionStore'
import './style.css'
import {
  initializeAidaLibraryAsync,
  loadAidaLibraryFromExternalUrl,
} from './composables/ChatCommunication'
import hljsVuePlugin from '@highlightjs/vue-plugin'

import './interceptors/axiosInterceptor'
console.info(
  `[AIDA_GENERIC_CLIENT] 🚀 App ${__APP_NAME__} v${__APP_VERSION__} built at ${__BUILD_DATE__}`
)

const app = createApp(App)
const pinia = createPinia()

app.use(pinia).use(i18n)

const appStore = useAppStore()
const aidaSessionStore = useAidaSessionStore()
const config = await loadConfigurationAsync()

loadAidaLibraryFromExternalUrl()

let aidaLibrary = await initializeAidaLibraryAsync()

appStore.setConfiguration(config!)
aidaSessionStore.setAidaClient(
  aidaLibrary,
  import.meta.env.VITE_AIDA_LIBRARY_CLIENT_NAME,
  import.meta.env.VITE_AIDA_LIBRARY_CLIENT_KEY
)

app.use(router)
app.use(hljsVuePlugin)
await router.isReady()
app.mount('#app')
